import { FC, ReactElement } from 'react';
import Spinner from 'src/view/components/Controls/Spinner/Spinner';

interface IProps {
  visible: boolean;
}

const Preloader: FC<IProps> = ({ visible }: IProps): ReactElement | null => {
  return visible ? (
    <div className="scroll-list-refreshing d-flex">
      <div className="d-flex flex-grow-1 justify-content-center m-auto">
        <Spinner />
      </div>
    </div>
  ) : null;
};

export default Preloader;
